import React from "react";
import { Helmet } from "react-helmet";
import Ad from "../components/Ad";


function Tutorials() {
  return (
    <>
         <Helmet>
      <title>Better Body & Mind — Wellness, Sleep, Nutrition & Mental Health</title>
      <meta
        name="description"
        content="Improve your health with science-backed tips on exercise, nutrition, sleep, and mindfulness. Practical wellness guidance for everyday life."
      />
      <link rel="canonical" href="https://aiandtechtoday.com/better-body-mind" />
    </Helmet>
    <div className="page">
      <header className="subhero">
        <h1>AI Tutorials</h1>
        <p>
          Hands-on guides that show you exactly how to use today’s top AI tools
          to save time, learn faster, and build things.
        </p>
      </header>

      {/* STARTER PATHS */}
      <section className="section">
        <h2>Start here: choose your path</h2>
        <div className="card-grid">
          <article className="card">
            <h3>Brand-new to AI</h3>
            <p>
              Learn how to set up ChatGPT, Gemini and Copilot, understand
              pricing and free tiers, and try your first simple prompts.
            </p>
          </article>
          <article className="card">
            <h3>Use AI at work or school</h3>
            <p>
              See how professionals use AI to draft emails, summarize meetings,
              analyze documents, and prepare reports in minutes instead of hours.
            </p>
          </article>
          <article className="card">
            <h3>Build smarter workflows</h3>
            <p>
              Turn AI into a personal assistant that remembers tasks, organizes
              notes, and helps you stay on top of projects across apps.
            </p>
          </article>
        </div>
      </section>

      {/* TUTORIAL LIST */}
      <section className="section">
        <h2>Featured tutorials</h2>
        <div className="tutorial-list">
          <article className="tutorial">
            <h3>1. Getting started with ChatGPT (or any chatbot)</h3>
            <p className="tutorial__meta">Difficulty: Easy • Time: 15 minutes</p>
            <ol>
              <li>Create an account with ChatGPT (or another assistant).</li>
              <li>
                Start with small tasks: ask it to rewrite an email, summarize an
                article, or explain a concept at “beginner level”.
              </li>
              
              <li>
                Use structured prompts like:
                <br />
                <ul>
                <li>
                  You are my writing assistant. I will paste a draft email.
                  First, summarize it in one sentence. Then rewrite it to sound
                  friendly and professional.
                </li>
                </ul>
              </li>

              <li>
                Experiment with follow-up prompts (“shorter”, “more direct”,
                “explain this like I’m 15”) to see how flexible the model is.
              </li>
            </ol>
          </article>

          <article className="tutorial">
            <h3>2. Using Gemini for research with real-time info</h3>
            <p className="tutorial__meta">Difficulty: Easy • Time: 20 minutes</p>
            <p>
              Gemini is tightly connected to Google’s ecosystem and can work
              well with current information, images, and your Google Drive
              files.
            </p>
            <ol>
              <li>Open Gemini in your browser or the mobile app.</li>
              <li>
                Ask a research question and include constraints, for example:
                <br />
                <ul>
                <li>
                  Research current AI tools used in education. Give me 5 tools,
                  their pricing, and one real-world use case each. Add links to
                  official pages.
                </li>
                </ul>
              </li>
              <li>
                Use follow-up questions like “Compare #2 and #4 for teachers”
                or “Explain this to a non-technical school principal”.
              </li>
              <li>
                Export or copy the answer into Docs or Slides and edit it into
                your final report.
              </li>
            </ol>
          </article>

            <Ad slot="1234567890" />

          <article className="tutorial">
            <h3>3. Turning AI into a code helper</h3>
            <p className="tutorial__meta">
              Difficulty: Intermediate • Time: 30–45 minutes
            </p>
            <p>
              Modern AI models can help you reason about code, suggest
              refactors, and generate tests. Some, like Copilot and GPT-based
              tools, plug directly into editors and IDEs.
            </p>
            <ol>
              <li>
                Pick one environment: GitHub Copilot, VS Code’s integrated AI,
                or a web-based assistant that supports coding.
              </li>
              <li>
                Paste a small function and ask:
                <br />
                <ul>
                <li>
                  Explain what this function does line by line, then suggest
                  cleaner and more readable code. Don’t change behavior.
                </li>
                </ul>
              </li>
              <li>
                Ask it to generate unit tests and edge cases you might have
                missed.
              </li>
              <li>
                Use the tool to explore new libraries or frameworks with prompts
                like: “Show me a minimal example of X in React / Python / Node.”
              </li>
            </ol>
          </article>

          <article className="tutorial">
            <h3>4. Create content with multimodal AI (text + images + video)</h3>
            <p className="tutorial__meta">Difficulty: Intermediate</p>
            <p>
              Generative AI tools now combine writing, image generation, and
              video. They’re used for marketing, education, and social content
              at scale.
            </p>
            <ul>
              <li>Use a text assistant (ChatGPT, Gemini, Claude) to draft a script.</li>
              <li>
                Use an AI image generator (Midjourney, DALL·E, Stable
                Diffusion) to create thumbnails or illustrations.
              </li>
              <li>
                Try a video generator like Runway to turn scripts into short
                explainer clips.
              </li>
            </ul>
          </article>
        </div>
      </section>
    </div>

    <Ad slot="1234567890" />
    </>
  );
}

export default Tutorials;